module.exports = __webpack_public_path__ + "img/image2.0b800d30.png";